import { Outlet } from "react-router-dom";

export const CreateBase = (props:any) => {
  
    return (
        props.children
    )
  }